var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPytorchOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE4C2C",
    d: "M100.1 38.3l-9.2 9.2c15.1 15.1 15.1 39.4 0 54.3-15.1 15.1-39.4 15.1-54.3 0-15.1-15.1-15.1-39.4 0-54.3l24-24 3.4-3.4V2L27.8 38.2C7.7 58.3 7.7 90.8 27.8 111s52.6 20.1 72.4 0c20.1-20.2 20.1-52.5-.1-72.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#EE4C2C",
    transform: "rotate(-88.939 82.069 29.398) scale(.99997)",
    cx: 82.1,
    cy: 29.4,
    r: 6.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorchOriginal);
export default __webpack_public_path__ + "static/media/pytorch-original.091d29874e55ca1389ecf4a0eb434553.svg";
export { ForwardRef as ReactComponent };